import { useToggleSettings } from "../../hooks/use-toggle-settings"
import { useSettings } from "../../modules/settings"

type OnOffAppSetting<Section extends AppSettingsKey> = {
  [P in keyof AppSettings[Section]]: AppSettings[Section][P] extends OnOff
    ? P
    : never
}[keyof AppSettings[Section]]

export function useToggleAppSetting<Section extends AppSettingsKey>(
  section: Section,
  prop: OnOffAppSetting<Section>,
) {
  const { appSettings, setAppSettings } = useSettings()

  const { isOn, toggle } = useToggleSettings({
    // SAFETY: prop is typed as OnOffAppSetting, value is OnOff
    currentValue: appSettings[section][prop] as OnOff,
    setValue: newValue=> {
      setAppSettings(String(prop), newValue, section)
    },
  })

  return [isOn, toggle] as const
}

export function useToggleHaveYouSeenItSetting(
  prop: OnOffAppSetting<"haveYouSeenIt">,
) {
  const [value, setValue] = useToggleAppSetting("haveYouSeenIt", prop)
  return [value, setValue] as const
}

export function useToggleRevealItSetting(prop: OnOffAppSetting<"revealIt">) {
  const [value, setValue] = useToggleAppSetting("revealIt", prop)
  return [value, setValue] as const
}
